import './sass/main.sass';
import {Routes, Route} from "react-router-dom";
import Login from "./pages/Login";
import Home from "./pages/Home";
import ApplicantManagement from "./features/applicant/ApplicantManagement";
import DriverManagement from "./features/driver/DriverManagement";
import RequestsManagement from "./features/request/RequestsManagement";
import UsersManagement from "./features/user/UsersManagement";
import Reporting from "./features/report/Reporting";
import {useDispatch} from "react-redux";
import {getCities} from "./features/common-states/commonStatesSlice";
import { useEffect } from 'react';

function App() {
const dispatch = useDispatch();

useEffect(() => {
  const token = localStorage.getItem('token');

  if (token) {
    dispatch(getCities());
  }
}, [dispatch]);
  return (
    <div className="text-center m-0 p-0 box-border">
      <Routes>
        <Route path='/' element={<Login />} />
        <Route path='home' element={<Home />}>
            <Route path='applicant' element={<ApplicantManagement />} />
            <Route path='driver' element={<DriverManagement />} />
            <Route path='request' element={<RequestsManagement />} />
            <Route path='report' element={<Reporting />} />
            <Route path='users' element={<UsersManagement />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
